export default {
  tipoTransporte: {
    value: '',
    maxlength: '255',
    required: true,
    state: null
  },
  valor: {
    value: 0,
    required: true,
    state: null
  },
  inactive: {
    value: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/visitas/kmValue/components/add/kmValue-form.js